/**
 * Belle Soié — Luxury Micro-Interactions (v2, speed-tuned Sep 30 2026)
 * Same effects as v1, but:
 *  - header scroll styling only touches the DOM when the state actually changes
 *    (v1 rewrote inline styles on every scroll event, forcing style recalcs)
 *  - one delegated listener per effect instead of a listener on every button
 *  - shimmer keyframes live in belle-soie-luxury.css instead of being injected here
 */
(function () {
  'use strict';

  /* ── STICKY HEADER SCROLL EFFECT ── */
  var header = document.querySelector('#header-group header, .header, header-component');
  if (header) {
    var SCROLL_THRESHOLD = 60;
    var isScrolled = null;
    var ticking = false;

    var applyState = function () {
      ticking = false;
      var next = window.scrollY > SCROLL_THRESHOLD;
      if (next === isScrolled) return;
      isScrolled = next;
      if (next) {
        header.setAttribute('data-scrolled', 'true');
        header.style.setProperty('--header-bg-opacity', '0.97');
        header.style.boxShadow = '0 2px 24px rgba(26,22,20,0.08)';
      } else {
        header.removeAttribute('data-scrolled');
        header.style.setProperty('--header-bg-opacity', '0.96');
        header.style.boxShadow = 'none';
      }
    };

    window.addEventListener('scroll', function () {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(applyState);
      }
    }, { passive: true });

    applyState();
  }

  /* ── WISHLIST HEART ANIMATION (delegated) ── */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[class*="wishlist"], [aria-label*="wishlist" i]');
    if (!btn) return;
    btn.classList.toggle('bs-wishlisted');
    var svg = btn.querySelector('svg path, svg circle');
    if (svg) {
      var on = btn.classList.contains('bs-wishlisted');
      svg.style.fill = on ? '#C9A96E' : 'none';
      svg.style.stroke = on ? '#C9A96E' : 'currentColor';
    }
    btn.style.transform = 'scale(1.3)';
    setTimeout(function () { btn.style.transform = ''; }, 300);
  });

  /* ── GOLD SHIMMER ON CTA HOVER (mouse/trackpad only, delegated) ── */
  if (window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    document.addEventListener('mouseover', function (e) {
      var btn = e.target.closest && e.target.closest('.button, .btn, [class*="button--primary"]');
      if (!btn || btn.contains(e.relatedTarget) || btn.querySelector('.bs-shimmer')) return;
      var shimmer = document.createElement('span');
      shimmer.className = 'bs-shimmer';
      btn.style.position = 'relative';
      btn.style.overflow = 'hidden';
      btn.appendChild(shimmer);
      shimmer.addEventListener('animationend', function () { shimmer.remove(); });
    });
  }

  /* ── ANNOUNCEMENT BAR: Pause marquee on hover ── */
  var marquee = document.querySelector('.announcement-bar [class*="marquee"], announcement-bar .marquee');
  if (marquee) {
    marquee.addEventListener('mouseenter', function () { marquee.style.animationPlayState = 'paused'; });
    marquee.addEventListener('mouseleave', function () { marquee.style.animationPlayState = 'running'; });
  }

  /* ── SIZE GUIDE: pointer cursor ── */
  document.querySelectorAll('[data-size-guide], [id*="size-guide"]').forEach(function (trigger) {
    trigger.style.cursor = 'pointer';
    trigger.style.transition = 'color 0.2s ease';
  });
})();
